import { Box, Carousel, Image, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

const ProductLink = styled(Typography).attrs({
  as: Link,
})`
  display: inline-block;
  padding: 16px 10px;
  text-align: center;
  width: auto;
  &:focus-visible {
    outline-offset: -2px;
  }
`

const ProductsList = ({
  displayArrows,
  justifyContent,
  linkClickData,
  name,
  products,
  showScrollBar,
}) => {
  return (
    <Carousel
      darkArrow
      data-cy="product-recommendation"
      displayArrows={products.length > 2 ? displayArrows : "none"}
      justifyContent={
        justifyContent || {
          desktop: "flex-start",
          tablet: "flex-start",
          widescreen: "flex-start",
        }
      }
      name={name}
      px={1}
      showScrollBar={showScrollBar}
    >
      {products.map((product, i) => {
        const imgUrl = `${sl.config.full_main_render_url}${
          product.style_code
        }?view=${product.view_collection_main || "t4"}`

        const onSale = product.reg_price !== product.price

        return (
          <ProductLink
            data-lc={linkClickData}
            key={`prec${product.name}${i}`}
            to={`/products/${product.style_code}/${product.permalink}`}
          >
            <Box height="130px" width="130px">
              <Image
                alt={product.name}
                height="130px"
                ratio="245 / 245"
                sizes="(max-width: 375px) 65vw, (max-width: 767px) 60vw, (min-width: 768px) 245px"
                src={`${imgUrl}&dim=245`}
                srcSet={`
                ${imgUrl}&dim=245 245w,
                ${imgUrl}&dim=490 490w,
              `}
                width="130px"
              />
            </Box>
            <Typography color="neutral" fontSize={12}>
              from
            </Typography>
            <Typography color="neutral" fontSize={12}>
              {onSale && (
                <>
                  <strike>({product.retail_price})</strike>{" "}
                </>
              )}
              <Typography as="span" color={onSale ? "sale" : "neutral"}>
                {product.price}
              </Typography>
            </Typography>

            {product.is_jlux && (
              <Typography
                color="neutral"
                fontSize={12}
                italic
                letterSpacing="0"
                light
              >
                Plus {jewlr_t("terms.center")} stone
              </Typography>
            )}
          </ProductLink>
        )
      })}
    </Carousel>
  )
}

ProductsList.propTypes = {
  displayArrows: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  justifyContent: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  linkClickData: PropTypes.string,
  name: PropTypes.string,
  products: PropTypes.array,
  showScrollBar: PropTypes.bool,
}

export default ProductsList
